import pdfMake from 'pdfmake/build/pdfmake';
import Logo from 'Icons/RMlogo.png';
import ExperimentDtoClient from 'business/models/ExperimentDtoClient';
import { createPdfWithPopupBlockerHandler } from './utils';
import { fonts } from './ReportsConstants';

pdfMake.fonts = { Roboto: fonts.Roboto };

export const TABLE_LAYOUT = {
  hLineWidth: function (i, node) {
    return 0.5;
  },
  vLineWidth: function (i, node) {
    return 0.5;
  },
};

export async function generateScreenStockReportPDF(
  expId: number,
  screenData: ExperimentDtoClient,
  platesData: any[],
  saveReport: boolean = false,
  onPopupBlocked?: () => void,
) {
  const pdfDefinition = {
    info: {
      title: screenData.expName + '-Screen Stock Report',
      author: 'Rock Maker',
      subject: 'Experiment',
    },
    content: await CreateContent(expId, screenData, platesData),
    styles: {
      headerText: { fontSize: 15, bold: true, lineHeight: 1.5 },
      largeText: { fontSize: 12, lineHeight: 1.5 },
      labelText: { fontSize: 8, lineHeight: 1.5 },
      tableSubHeader: { bold: true, fillColor: '#cccccc' },
      tableAltRow: { fillColor: '#f5f5f5' },
      textBold: { bold: true },
    },
    defaultStyle: {
      fontSize: 10,
      lineHeight: 1.5,
    },
    pageMargins: [50, 50, 50, 50],
    header: getHeader(),
    pageBreakBefore: false,
  };

  createPdfWithPopupBlockerHandler(
    pdfMake,
    pdfDefinition,
    screenData.expName + ' - Screen Stock Report',
    saveReport,
    onPopupBlocked,
  );
}

async function CreateContent(expId: number, screenData: any, platesData: any[]) {
  const content = [];
  content.push({ text: 'Screen Stocks List', alignment: 'center', style: 'headerText' });

  const screenIngredients: any[] = [];

  platesData.forEach((plate) => {
    if (plate.wellList) {
      plate.wellList.forEach((wl) => {
        wl.wellLayerList.forEach((wlayerlist) => {
          wlayerlist.wellLayerIngredientList.forEach((wIng) => {
            if (
              !screenIngredients.some(
                (sIng) => sIng.ingredientStockId === wIng.ingredientStockId,
              )
            ) {
              screenIngredients.push(wIng);
            }
          });
        });
      });
    }
  });

  content.push({ text: screenData.expName, style: 'largeText', bold: true });
  content.push(await getScreenStockInfoTable(screenIngredients));
  return content;
}

async function getScreenStockInfoTable(screenIngredients: any[]) {
  const tableBody: any[] = [
    [
      { text: 'Stock Concentration', fillColor: '#cccccc', bold: true },
      { text: 'Concentration Units', fillColor: '#cccccc', bold: true },
      { text: 'pH', fillColor: '#cccccc', bold: true },
      { text: 'Vendor Name', fillColor: '#cccccc', bold: true },
      { text: 'Vendor Part Number', fillColor: '#cccccc', bold: true },
    ],
  ];

  screenIngredients.forEach((sIng) => {
    if (sIng.highPhIngStock) {
      tableBody.push(
        [
          { text: sIng.ingredientStockIngredient.longName, bold: true, colSpan: 5 },
          {},
          {},
          {},
          {},
        ],
        [
          sIng.highPhIngStock.stockConcentration,
          sIng.highPhIngStock.concentrationUnits,
          sIng.highPhIngStock.stockPh,
          sIng.highPhIngStock.vendor ? sIng.highPhIngStock.vendor?.name : null,
          sIng.highPhIngStock.vendorPartNumber,
        ],
        [
          sIng.ingredientStock.stockConcentration,
          sIng.ingredientStock.concentrationUnits,
          sIng.ingredientStock.stockPh,
          sIng.ingredientStock.vendor ? sIng.ingredientStock.vendor?.name : null,
          sIng.ingredientStock.vendorPartNumber,
        ],
      );
    } else {
      tableBody.push(
        [
          { text: sIng.ingredientStockIngredient.longName, bold: true, colSpan: 5 },
          {},
          {},
          {},
          {},
        ],
        [
          sIng.ingredientStock.stockConcentration,
          sIng.ingredientStock.concentrationUnits,
          sIng.ingredientStock.stockPh,
          sIng.ingredientStock.vendor ? sIng.ingredientStock.vendor?.name : null,
          sIng.ingredientStock.vendorPartNumber,
        ],
      );
    }
  });

  return {
    table: {
      widths: ['23%', '20%', '7%', '25%', '25%'],
      body: tableBody,
    },
    layout: TABLE_LAYOUT,
  };
}

function getHeader() {
  return [
    {
      columns: [
        {
          image: Logo,
          width: 20,
          height: 20,
        },
        {
          text: 'ROCK MAKER®',
          margin: [5, 4, 0, 0],
          width: 400,
          fontSize: 12,
          color: '#707070',
        },
        {
          text: 'Printed On: ' + new Date().toLocaleDateString('en-US'),
          margin: [0, 5, 0, 0],
          color: '#707070',
        },
      ],
      margin: [20, 20, 20, 20],
    },
  ];
}
